var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"btn"},[_c('el-button',{attrs:{"plain":""},on:{"click":_vm.handleClick}},[_vm._v("返回首页")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }